import {TRANSLATION, Yup} from '@/imports-files/pages/admins/dashboard/clients/new';
import moment from 'moment';


export const WEEKDAYS = [
                            {id: 0, day: "Monday", state: true},
                            {id: 1, day: "Tuesday", state: true},
                            {id: 2, day: "Wednesday", state: true},
                            {id: 3, day: "Thursday", state:true},
                            {id: 4, day: "Friday", state:true},
                            {id: 5, day: "Saturday", state:true},
                            {id: 6, day: "Sunday", state:true}
                        ];

export const TIMEINTERVAL       =  {
                                        options: [
                                                    {value: null, label: "Please select"},
                                                    {value: 15, label: "15"},
                                                    {value: 30, label: "30"},
                                                    {value: 45, label: "45"},
                                                    {value: 60, label: "60"},
                                                    {value: 90, label: "90"}
                                                 ]
                                    };

export const INITIAL_VALUES     =  createInitialValues(WEEKDAYS);

export const VALIDATION_SCHEMA  =  Yup.object().shape({
                                                        users: Yup.object({ preferences_attributes: Yup.array().of(
                                                                                                                    Yup.object({
                                                                                                                                    isDisabled  :  Yup.boolean(),
                                                                                                                                    weekday     :  Yup.string().required(TRANSLATION('common:errors:required')),
                                                                                                                                    start_time  :  Yup.string().when('isDisabled',{ is: false, then: Yup.string().required(TRANSLATION('common:errors:required'))})
                                                                                                                                                               .when('isDisabled',{ is: false, then: Yup.string().test("is-correct", "Please select valid start time.", function(value) {
                                                                                                                                                                                                                          return isCorrectTime(value)
                                                                                                                                                                                                                    })}),
                                                                                                                                    end_time    :  Yup.string().when('isDisabled',{ is: false, then: Yup.string().required(TRANSLATION('common:errors:required'))})
                                                                                                                                                               .when('isDisabled',{ is: false, then: Yup.string().test("is-correct", "Please select valid end time.", function(value) {
                                                                                                                                                                                                                          return isCorrectTime(value)
                                                                                                                                                                                                                    })})
                                                                                                                                                               .when('isDisabled',{ is: false, then: Yup.string().test("is-greater", "End time should be greater than start time.", function(value) {
                                                                                                                                                                                                                          const { start_time } = this.parent;
                                                                                                                                                                                                                          return isValidTime(start_time, value)
                                                                                                                                                                                                                    })})
                                                                                                                                                               .when('isDisabled',{ is: false, then: Yup.string().test("is-equal", "Start and end times can not be equal. Please select valid times.", function(value) {
                                                                                                                                                                                                                          const { start_time } = this.parent;
                                                                                                                                                                                                                          return isEqualTime(start_time, value)
                                                                                                                                                                                                                    })})
                                                                                                                               })
                                                                                                                 ),
                                                                            client_user_attributes: Yup.object({
                                                                                                                    buffer_before_interview : Yup.string().nullable(true),
                                                                                                                    buffer_after_interview  : Yup.string().nullable(true)
                                                                                                              })
                                                                          })
                                                    });


export function createInitialValues(WEEKDAYS)
{
    let initialValues = {
                            users: {
                                        preferences_attributes: [],
                                        client_user_attributes: {
                                                                    buffer_before_interview: '',
                                                                    buffer_after_interview: '',
                                                                    timezone: ''
                                                                }
                                    }
                        };

    for( let element of WEEKDAYS )
    {
        initialValues.users.preferences_attributes.push({
                                                            isDisabled: true,
                                                            weekday: element.id,
                                                            start_time: '',
                                                            end_time: '',
                                                            _destroy: true
                                                        })


    }
    return initialValues;

}

export function isValidTime(start_time, end_time){
  let start_int = parseInt(start_time.replace(':', '')) 
  let end_int = parseInt(end_time.replace(':', ''))
  if(start_time.includes('-') || end_time.includes('-'))
    return true 
  return start_int <= end_int 
}

export function isEqualTime(start_time, end_time){
  let start_int = parseInt(start_time.replace(':', '')) 
  let end_int = parseInt(end_time.replace(':', ''))
  if(start_time.includes('-') || end_time.includes('-'))
    return true 
  return start_time != end_time 
}

export function weekDayData(element){
  let isEnableDay = false || (element.id < 5)
  return {
    isDisabled: !isEnableDay,
    weekday: element.id,
    start_time: isEnableDay ? '09:00' : '',
    end_time: isEnableDay ? '17:00' : '',
    _destroy: !isEnableDay
  }
}


export function isCorrectTime(value){
  let time = value.replace(':', '')
  return !time.includes('-')
}
